import {Component, Input, OnInit} from '@angular/core';
import {VorhersageTag} from "../../../../../../../model/vorhersagen/vorhersage-zehn-tage";
import {MatTableDataSource} from "@angular/material/table";
import {DatastoreService} from "../../../../../../../service/datastore/datastore.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {VorhersageMesswerte} from "../../../../../../../model/vorhersagen/vorhersage-messwerte";
import {CommonConstants} from "../../../../../../../util/common-constants";
import {WerteConverterUtil} from "../../../../../../../util/werte-converter-util";

@Component({
  selector: 'app-drei-stunden-vorhersage-table',
  templateUrl: './drei-stunden-vorhersage-table.component.html',
  styleUrls: ['../../vorhersagen-table-styles.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class DreiStundenVorhersageTableComponent implements OnInit {

  displayedColumns = CommonConstants.VORHERSAGE_TABLE_COLUMNS_TO_DISPLAY;

  expandedElement: VorhersageTag | null;

  dataSource = new MatTableDataSource<VorhersageMesswerte>();

  dataSources: MatTableDataSource<VorhersageMesswerte>[];

  @Input() vorhersageTage: VorhersageTag[];


  constructor(public datastoreService: DatastoreService,public werteConverter: WerteConverterUtil) {
  }

  ngOnInit(): void {
    this.dataSources = [];
    for (let tag of this.vorhersageTage) {
      this.dataSources.push(new MatTableDataSource<VorhersageMesswerte>(tag.werteListeDreiStunden));
    }
  }

}
